import React from "react";
import successicon from "../../../assets/successIcon.svg";
import NotificationCard from "../NotificationCard/NotificationCard";
import { NotificationCardProp } from "../NotificationCard/NotificationCard";
import "./SuccessCard.scss";

const SuccessCard: React.FC<NotificationCardProp> = ({
  title,
  subtitle,
  children,
  className,
  closeModal,
}) => {
  return (
    <NotificationCard
      icon={
        <svg
          id="Property1=Success"
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ maxWidth: "100%", maxHeight: "100%;" }}
        >
          <g clipPath="url(#clip0_19313_94156)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.0001 11.0001C21.7453 11.0001 11.0001 21.7453 11.0001 35.0001C11.0001 48.2549 21.7453 59 35.0001 59C48.2549 59 59 48.2549 59 35.0001C59 21.7453 48.2549 11.0001 35.0001 11.0001ZM46.3007 29.4902C47.2358 28.5509 47.2325 27.0313 46.2932 26.0961C45.3538 25.1609 43.8342 25.1642 42.8991 26.1036L30.2595 38.799L27.0967 35.6363C26.1594 34.6991 24.6398 34.6991 23.7025 35.6364C22.7653 36.5737 22.7653 38.0933 23.7026 39.0305L28.5663 43.894C29.017 44.3447 29.6286 44.5976 30.266 44.5969C30.9034 44.5962 31.5144 44.3419 31.9641 43.8902L46.3007 29.4902Z"
              fill="#1AAA55"
              strokeDasharray="0,0,0,219.2597198486328"
            >
              <animate
                attributeType="XML"
                attributeName="strokeDasharray"
                repeatCount="1"
                dur="1.1111111111111112s"
                values="0,0,0,219.2597198486328; 
                0,109.6298599243164,109.6298599243164,0; 
                219.2597198486328,0,0,0"
                keyTimes="0; 0.5; 1"
                fill="freeze"
              ></animate>
            </path>
          </g>
          <rect
            x="5.9"
            y="5.9"
            width="58.2"
            height="58.2"
            rx="29.1"
            stroke="#1AAA55"
            strokeOpacity="0.28"
            strokeWidth="10.2"
            strokeDasharray="0,0,0,182.5453338623047"
          >
            <animate
              attributeType="XML"
              attributeName="strokeDasharray"
              repeatCount="1"
              dur="1.1111111111111112s"
              values="0,0,0,182.5453338623047; 
                0,91.27266693115234,91.27266693115234,0; 
                182.5453338623047,0,0,0"
              keyTimes="0; 0.5; 1"
              fill="freeze"
            ></animate>
          </rect>
          <defs>
            <clipPath id="clip0_19313_94156">
              <rect
                x="11"
                y="11"
                width="48"
                height="48"
                rx="24"
                fill="white"
                strokeDasharray="0,0,0,149.82472229003906"
              >
                <animate
                  attributeType="XML"
                  attributeName="strokeDasharray"
                  repeatCount="1"
                  dur="1.1111111111111112s"
                  values="0,0,0,149.82472229003906; 
                0,74.91236114501953,74.91236114501953,0; 
                149.82472229003906,0,0,0"
                  keyTimes="0; 0.5; 1"
                  fill="freeze"
                ></animate>
              </rect>
            </clipPath>
          </defs>
        </svg>
      } 
      title={title}
      subtitle={subtitle}
      className={`success-card ${className}`}
      closeModal={closeModal}
      children={children}
    />
  );
};

export default SuccessCard;
